export const NOTE_SELECTOR =
  'affine-note, affine-edgeless-note .edgeless-note-page-content, affine-edgeless-text';
